var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF485A"
    },
    d: "M318.136,458.514H49.709v-84.505c0.06-41.159,33.404-74.503,74.563-74.563h97.727h4.971 c81.642,0.338,148.112-65.566,148.45-147.217c0.338-81.652-65.566-148.102-147.217-148.45S80.101,69.354,79.753,150.996 c-0.149,36.377,13.113,71.531,37.262,98.741C51.25,253.635-0.06,308.135,0,374.009v109.359c0,13.73,11.125,24.854,24.854,24.854 h293.282c13.73,0,24.854-11.125,24.854-24.854S331.866,458.514,318.136,458.514z M226.97,54.879 c53.845,1.541,96.246,46.428,94.705,100.272c-1.442,50.604-41.378,91.693-91.921,94.586h-7.755 c-53.755-3.38-94.596-49.699-91.216-103.454C133.985,95.332,175.929,55.476,226.97,54.879z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBBC0"
    },
    d: "M487.146,398.864H338.019c-13.73,0-24.854-11.125-24.854-24.854s11.125-24.854,24.854-24.854 h149.126c13.73,0,24.854,11.125,24.854,24.854S500.875,398.864,487.146,398.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBBC0"
    },
    d: "M412.583,473.427c-13.73,0-24.854-11.125-24.854-24.854V299.446 c0-13.73,11.125-24.854,24.854-24.854s24.854,11.125,24.854,24.854v149.126C437.437,462.302,426.312,473.427,412.583,473.427z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.edbf98aa.svg";
export { ForwardRef as ReactComponent };